// Packages
import axios from "axios";
import { AuthResult } from "../context/authprovider";

// Still not working
// Might remove
export const setAuthToken = (token: string) => {
  if (token) {
    localStorage.setItem("accessToken", token)
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

export const getAuthToken = () => {
  const token = localStorage.getItem("accessToken");
  if(token && token !== "") {
    return token;
  }
  return null;
}

export const getStartAuthDetails = () => {
  const userInfo = localStorage.getItem("userInfo");
  if (userInfo !== null) {
    try {
      const userData = JSON.parse(userInfo);
      return { ...userData, "isAuthenticated": true }
    } catch (e) {
        return null
    }
  }
  return null
};

export const setAuthData = (userData: AuthResult) => {
    localStorage.setItem("userInfo", JSON.stringify(userData));
}

export const clearAuthData = () => {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("accessToken");
}